// https://github.com/kenwheeler/slick

import $ from "jquery";
import { setFullWidthWrapper } from "./helper";
import "slick-carousel/slick/slick";
import "slick-carousel/slick/slick.css";

/****** SLIDERS *******/
const sliders = {
  home: $(".home-slider"),
  realisation: $("#realisation-slider")
};

sliders.home.slick({
  dots: false,
  autoplay: true,
  pauseOnFocus: false,
  pauseOnHover: false,
  prevArrow: $(".nav.prev"),
  nextArrow: $(".nav.next"),
  speed: 1000,
  autoplaySpeed: 5000
});

sliders.realisation.on("init", function() {
  setFullWidthWrapper(document.getElementById("flat-gallery"));
});

sliders.realisation.slick({
  dots: true,
  autoplay: true,
  arrows: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const homeSliderPaddingTop = () => {
  let $headerHeight = $(".site-header").outerHeight();
  sliders.home.find(".single-slide").css("padding-top", $headerHeight + 15);
};
homeSliderPaddingTop();
